<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Kredit stop</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content class="align-center">
  @if (kreditvurdering.kreditvaerdig === kreditvaerdigEnum.No) {
    <div>
      <p class="orange med-text align-center">
        <mat-icon svgIcon="obs-solid" class="icon-48"></mat-icon>
        <br />
        <span>Kunden er ikke kreditværdig!</span>
        <br />
        <span>
          <em>{{ kreditvurdering?.aarsagTekst }}</em>
        </span>
      </p>
    </div>
  }

  @if (kreditvurdering.kreditvaerdig === kreditvaerdigEnum.Yes) {
    <div>
      <p class="green med-text align-center">
        <mat-icon svgIcon="checkmark" class="icon-48"></mat-icon>
        <br />
        <span>Kunden kreditværdig!</span>
        <br />
      </p>
    </div>
  }

  @if (kreditvurdering.kreditvaerdig === kreditvaerdigEnum.Maybe || kreditvurdering.kreditvaerdig === kreditvaerdigEnum.NotSet) {
    <div>
      <p class="orange med-text align-center">
        <mat-icon svgIcon="obs-solid" class="icon-48"></mat-icon>
        <br />
        <span>Kunden er ikke kreditværdig!</span>
        <br />
        <span>
          <em>{{ kreditvurdering?.aarsagTekst }}</em>
        </span>
      </p>
      <p>Hvad skal der ske med ordren?</p>
      <form [formGroup]="form" [attr.autocomplete]="'off'">
        @if (kreditvurdering?.kreditvaerdig === kreditvaerdigEnum.Maybe || kreditvurdering?.kreditvaerdig === kreditvaerdigEnum.NotSet) {
          <div
            class="form-row"
            >
            <mat-checkbox formControlName="accept">Jeg er opmærksom på at kunden ikke er kreditværdig</mat-checkbox>
          </div>
        }
        @if (accept.value) {
          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>Bemærkning</mat-label>
              <input formControlName="acceptTekst" matInput maxlength="32" />
              <mat-hint align="end">
                <app-character-count [control]="acceptTekst" [maxlength]="32"></app-character-count>
              </mat-hint>
              @if (acceptTekst.hasError('maxlength')) {
                <mat-error>Fakturanote må højest være 32 karakterer lang.</mat-error>
              }
            </mat-form-field>
          </div>
        }
      </form>
    </div>
  }
  @if (deadlineAfterPartnerEnd) {
    <div class="orange icon-with-text">
      <mat-icon svgIcon="obs-solid"></mat-icon>
      <span>Bemærk: Ordrens deadline ligger efter partnerns slutdato</span>
    </div>
  }
  <div mat-dialog-actions class="align-center">
    @if (kreditvurdering?.kreditvaerdig == kreditvaerdigEnum.Yes || kreditvurdering?.kreditvaerdig == kreditvaerdigEnum.Maybe) {
      <button
        mat-raised-button
        (click)="approve()"
        [disabled]="$safeNavigationMigration(form?.invalid)"
        matTooltip="Ordren går igennem som normalt"
        >
        Godkend ordren
      </button>
    }
    @if (kreditvurdering?.kreditvaerdig !== kreditvaerdigEnum.Yes || deadlineAfterPartnerEnd) {
      <button
        mat-raised-button
        (click)="cancel()"
        matTooltip="Ordren får noten: Annulleret fordi kunden ikke er kreditværdig"
        >
        Annuller ordren
      </button>
    }
  </div>
</div>
